import { toast } from 'react-hot-toast';

export const toastSuccess = (msg: string) => toast.success(msg);

export const toastError = (msg: string, err?: unknown) => {
  const detail =
    err && typeof err === 'object' && 'message' in err
      ? `: ${(err as Error).message}`
      : '';
  toast.error(`${msg}${detail}`);
};
